import Keycloak from "keycloak-js"
import env from "./context/Env"

const keycloakConfig = {
    clientId: env("KEYCLOAK_CLIENT_ID") || "",
    realm: env("KEYCLOAK_REALM") || "",
    url: env("KEYCLOAK_HOST") || "",
}
const keycloak = new Keycloak(keycloakConfig)
export default keycloak
